<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// 为什么选择我们
const props = defineProps({
    footer: {
        type: Object,
        default: () => ({ webname: '汇来云' })
    }
})

</script>

<template>
    <div class="Heziyun-choice Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('index.choice11') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('index.choice12') }}</p>
            </div>

            <div class="Heziyun-selectContent">
                <div class="Heziyun-itemChoose" v-intersect="{ class: 'left-right', delay: 0 }">
                    <img src="@/static/img/index/itemChoose5.png" alt="" />
                    <span>{{ $t('index.choice13') }}</span>
                    <p>{{ $t('index.choice14') }}</p>
                    <div class="Heziyun-label">
                        <a-tooltip :content="t('index.choice15')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice15') }}</div>
                        </a-tooltip>
                        <a-tooltip :content="t('index.choice16')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice16') }}</div>
                        </a-tooltip>
                        <a-tooltip :content="t('index.choice17')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice17') }}</div>
                        </a-tooltip>
                    </div>
                </div>
                <div class="Heziyun-itemChoose" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <img src="@/static/img/index/itemChoose6.png" alt="" />
                    <span>{{ $t('index.choice18') }}</span>
                    <p>{{ $t('index.choice19') }}</p>
                    <div class="Heziyun-label">
                        <a-tooltip :content="t('index.choice20')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice20') }}</div>
                        </a-tooltip>
                        <a-tooltip :content="t('index.choice21')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice21') }}</div>
                        </a-tooltip>
                        <a-tooltip :content="t('index.choice22')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice22') }}</div>
                        </a-tooltip>
                    </div>
                </div>
                <div class="Heziyun-itemChoose" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <img src="@/static/img/index/itemChoose7.png" alt="" />
                    <span>{{ $t('index.choice23') }}</span>
                    <p>{{ $t('index.choice24') }}</p>
                    <div class="Heziyun-label">
                        <a-tooltip :content="t('index.choice25')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice25') }}</div>
                        </a-tooltip>
                        <a-tooltip :content="t('index.choice26')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice26') }}</div>
                        </a-tooltip>
                        <a-tooltip :content="t('index.choice27')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice27') }}</div>
                        </a-tooltip>
                    </div>
                </div>
                <div class="Heziyun-itemChoose" v-intersect="{ class: 'right-left', delay: 600 }">
                    <img src="@/static/img/index/itemChoose8.png" alt="" />
                    <span>{{ $t('index.choice28') }}</span>
                    <p>{{ $t('index.choice29') }}</p>
                    <div class="Heziyun-label">
                        <a-tooltip :content="t('index.choice30')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice30') }}</div>
                        </a-tooltip>
                        <a-tooltip :content="t('index.choice31')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice31') }}</div>
                        </a-tooltip>
                        <a-tooltip :content="t('index.choice32')">
                            <div class="Heziyun-item Heziyun-textOverflow">{{ $t('index.choice32') }}</div>
                        </a-tooltip>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
// 为什么选择我们
.Heziyun-choice {
    position: relative;
    background-color: #f9fafc;

    .Heziyun-imgs {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    .Heziyun-commodity-title {
        position: relative;
    }

    .Heziyun-defaultWidth {


        .Heziyun-selectContent {
            position: relative;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 1rem;

            .Heziyun-itemChoose {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 0.7rem;
                padding: 1.5rem 2rem;
                padding-bottom: 4rem;
                background-color: #fff;
                border: 1px solid #E6E9EC;
                box-shadow: 0px 2px 7px 0px #F2F5F7;
                cursor: pointer;
                position: relative;

                &:hover {
                    box-shadow: 0 10px 20px 0 rgba(192, 205, 232, 0.3), 0 0 2px 0 rgba(37, 56, 108, 0.1);
                    border: 1px solid #0056ff;
                }

                img {
                    width: 3.5rem;
                    height: 6rem;
                    object-fit: contain;
                }

                span {
                    color: #181818;
                    font-family: "思源黑";
                    font-size: 1rem;
                }

                p {
                    color: #181818;
                    line-height: 1.7;
                }

                .Heziyun-label {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    position: absolute;
                    width: calc(100% - 4rem);
                    left: 2rem;
                    bottom: 1.5rem;

                    .Heziyun-item {
                        font-size: 12px;
                        border: 1px solid #f1f2f5;
                        color: #000;
                        font-weight: 400;
                        line-height: 1.7;
                        padding: 1px 10px;
                        background-color: #f7f7f7;
                    }
                }
            }
        }
    }

    .Heziyun-commodity-title2 {
        padding-top: 5rem;
    }

    .partners-section {
        width: 100%;
        overflow: hidden;
        position: relative;
        mask-image: linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%);
        display: flex;
        flex-direction: column;
        gap: 1.2rem;

        &:hover {
            .partners-track {
                animation-play-state: paused;
            }
        }

        @keyframes animationOne {
            from {
                transform: translate(100%);
                -webkit-transform: translate(100%);
                -moz-transform: translate(100%);
                -ms-transform: translate(100%);
                -o-transform: translate(100%);
            }

            to {
                transform: translate(-100%);
                -webkit-transform: translate(-100%);
                -moz-transform: translate(-100%);
                -ms-transform: translate(-100%);
                -o-transform: translate(-100%);
            }
        }

        @keyframes animationTwos {
            from {
                transform: translate(0%);
                -webkit-transform: translate(0%);
                -moz-transform: translate(0%);
                -ms-transform: translate(0%);
                -o-transform: translate(0%);
            }

            to {
                transform: translate(-200%);
                -webkit-transform: translate(-200%);
                -moz-transform: translate(-200%);
                -ms-transform: translate(-200%);
                -o-transform: translate(-200%);
            }
        }

        .partners-track {
            margin: 0 auto;
            transform: translateZ(0);
            backface-visibility: hidden;
            perspective: 1000px;
            will-change: transform;
            display: flex;

            div {
                display: flex;
                white-space: nowrap;
            }

            div:nth-child(1) {
                animation: animationOne var(--t) linear infinite;
                -webkit-animation: animationOne var(--t) linear infinite;
            }

            div:nth-child(2) {
                animation: animationTwos var(--t) linear infinite;
                -webkit-animation: animationTwos var(--t) linear infinite;
                animation-delay: calc(var(--t) / -2);
            }
        }


        .partner-logo {
            flex: 0 0 auto;
            width: 13rem;
            height: 4rem;
            padding: 0.5rem;
            margin: 0 3rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: transparent;

            &:hover {
                background-color: rgb(203 203 203 / 10%);
            }
        }

        .partner-logo img {
            max-width: 80%;
            max-height: 80%;
            object-fit: contain;
        }
    }


}

// 为什么选择我们
@media (max-width: 768px) {
    .Heziyun-choice {
        padding: 8vw 0;

        .Heziyun-defaultWidth {
            font-family: "思源黑";

            .Heziyun-selectContent {
                display: grid;
                grid-template-columns: repeat(1, 1fr);
                gap: 4vw;

                .Heziyun-itemChoose {
                    gap: 2vw;
                    padding: 6vw;
                    padding-bottom: 15vw;

                    img {
                        width: 15vw;
                        height: 15vw;
                    }

                    span {
                        font-size: 4vw;
                    }

                    p {
                        font-size: 3vw;
                    }


                    .Heziyun-label {
                        left: 6vw;
                        bottom: 5vw;

                        .Heziyun-item {
                            font-size: 3vw;
                            padding: 1px 10px;
                        }
                    }
                }
            }
        }
    }
}
</style>